import { LoadingPosition } from './LoadingButton.type';

import type { ButtonProps } from '@mui/material/Button';
import Loader from '@mui/material/CircularProgress';
import { StyledButton } from './LoadingButton.style';

type LoadingButtonProps = {
  loading?: boolean;
  loadingPosition?: LoadingPosition;
  loaderSize?: number;
} & ButtonProps;

const LoadingButton = ({
  children,
  loading = false,
  loadingPosition = 'end',
  loaderSize = 18,
  ...rest
}: LoadingButtonProps) => {
  return (
    <StyledButton {...rest} loadingPosition={loadingPosition}>
      {loadingPosition === 'start' && loading && <Loader size={loaderSize} />}
      {children}
      {loadingPosition === 'end' && loading && <Loader size={loaderSize} />}
    </StyledButton>
  );
};

export default LoadingButton;
